import React from "react";

/**
 * KPI kartlarının satır içi ikonları.
 * @ant-design/icons 4.2'de tasarımdaki inceltilmiş ikonların karşılığı yok;
 * ölçü/çizgi kalınlığı tasarımla birebir olsun diye satır içi SVG kullanılıyor.
 */

const base = {
  width: 15,
  height: 15,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const MembersIcon = () => (
  <svg {...base}>
    <path d="M16 19v-1.5a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4V19" />
    <circle cx="9" cy="7" r="3.4" />
    <path d="M22 19v-1.5a4 4 0 0 0-3-3.87" />
  </svg>
);

export const CheckIcon = () => (
  <svg {...base}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const AnimalIcon = () => (
  <svg {...base}>
    <path d="M4 11V7.5A3.5 3.5 0 0 1 7.5 4h9A3.5 3.5 0 0 1 20 7.5V11" />
    <path d="M4 11h16v5.5A3.5 3.5 0 0 1 16.5 20h-9A3.5 3.5 0 0 1 4 16.5V11Z" />
  </svg>
);

export const MoneyIcon = () => (
  <svg {...base}>
    <path d="M12 3v18M17 7.5c0-2-2.2-3.5-5-3.5S7 5.5 7 7.5s2.2 3 5 3.5 5 1.5 5 3.5-2.2 3.5-5 3.5-5-1.5-5-3.5" />
  </svg>
);

export const AlertIcon = () => (
  <svg {...base}>
    <path d="M12 8v5M12 16.5v.5" />
    <circle cx="12" cy="12" r="9" />
  </svg>
);

export const MilkIcon = () => (
  <svg {...base}>
    <path d="M9 2h6l-.8 2.6a3 3 0 0 0 .25 2.3l1.2 2.1a4 4 0 0 1 .5 1.95V19a3 3 0 0 1-3 3h-2.3a3 3 0 0 1-3-3v-8.05a4 4 0 0 1 .5-1.95l1.2-2.1a3 3 0 0 0 .25-2.3L9 2Z" />
  </svg>
);
